<template>
  <nav
    class="flex sticky w-full items-center justify-between px-6 h-16 bg-white text-gray-700 border-b border-gray-200 z-10 top-0"
  >
    <div class="flex items-center justify-between">
      <button class="mr-2" aria-label="Open Menu" @click="drawer">
        <svg
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          class="w-8 h-8"
        >
          <path d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>
    </div>
    <div>
      <button @click="logout">
        <svg
          class="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </button>
    </div>
    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out transition-medium"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="ease-out transition-medium"
      leave-to-class="opacity-0"
    >
      <div
        @keydown.esc="isOpen = false"
        v-show="isOpen"
        class="z-10 fixed inset-0 transition-opacity"
      >
        <div
          @click="isOpen = false"
          class="absolute inset-0 bg-black opacity-50"
          tabindex="0"
        ></div>
      </div>
    </transition>
    <aside
      class="transform top-0 left-0 w-64 bg-white fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30"
      :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
    >
      <span @click="isOpen = false" class=" w-full items-center border-b">
        <img src="../assets/logomenu.png" alt="Logo" class="w-full" />
      </span>

      <MenuItem
        v-for="menu in menus"
        :menu="menu"
        :key="menu.id"
        @click="goto"
      />
    </aside>
  </nav>
</template>

<script>
import MenuItem from "@/components/menuitem.vue";

export default {
  components: {
    MenuItem
  },
  data() {
    return {
      isOpen: false,
      isOpenConf: false,
      appmenus: [
        {
          id: 1,
          nombre: "Agenda Showroom",
          path: "agenda",
          icon:
            "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        },
        {
          id: 2,
          nombre: "Clientes",
          path: "clientes",
          icon:
            "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        },
        {
          id: 21,
          nombre: "Tiendas",
          path: "tiendas",
          icon:
            "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
        },
        {
          id: 3,
          nombre: "Fabricantes",
          path: "fabricantes",
          icon:
            "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        },
        {
          id: 4,
          nombre: "Pedidos",
          path: "pedidos",
          icon:
            "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
        },
        {
          id: 5,
          nombre: "Expediciones",
          path: "expediciones",
          icon: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
        },
        {
          id: 15,
          nombre: "Bandeja de expediciones",
          path: "inbox-expediciones",
          icon: "M22 12L16 12L14 15L10 15L8 12L2 12M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
        },
        {
          id: 6,
          nombre: "Comisiones",
          path: "comisiones",
          icon:
            "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
        },
        {
          id: 7,
          nombre: "Facturas",
          path: "facturas",
          icon:
            "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        },
        {
          id: 8,
          nombre: "Colecciones",
          path: "colecciones",
          icon:
            "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        },
        {
          id: 9,
          nombre: "Temporadas",
          path: "temporadas",
          icon:
            "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        } /*,
        {
          id: 11,
          nombre: "Transportistas",
          path: "transportistas",
          icon:
            "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
        }*/,
        {
          id: 12,
          nombre: "Poblaciones",
          path: "poblaciones",
          icon:
            "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        },
        {
          id: 13,
          nombre: "Configuración facturas",
          path: "configuracionfacturas",
          icon:
            "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
        },
        {
          id: 14,
          nombre: "Receptores de facturas",
          path: "receptoresfactura",
          icon:
            "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
        }
      ]
    };
  },
  computed: {
    menus: function() {
      if (
        localStorage.getItem("admin") ==
        localStorage
          .getItem("token")
          .split("")
          .reverse()
          .join("")
      ) {
        const adminMenu = [...this.appmenus];
        adminMenu.push({
          id: 15,
          nombre: "Usuarios",
          path: "usuarios",
          icon:
            "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
        });
        return adminMenu;
      }
      return this.appmenus;
    }
  },
  methods: {
    drawer() {
      this.isOpen = !this.isOpen;
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push({ path: `/login` });
    },
    goto(link) {
      const newpath = link;
      if (this.isOpen) {
        this.$router.push({ path: `/app/${newpath}` });
        this.isOpen = false;
      }
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (typeof window !== "undefined") {
          if (isOpen) {
            document.body.style.setProperty("overflow", "hidden");
          } else {
            document.body.style.removeProperty("overflow");
          }
        }
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (e.keyCode == 27 && this.isOpen) this.isOpen = false;
    });
  }
};
</script>